export default "/static/webpack/media/gma-example-01.2a6564b3.png";